<button
  [ngClass]="className"
  [title]="title"
  [disabled]="disabled || loading"
  [type]="type"
>
  <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  <ng-content></ng-content>
</button>
